import * as React from 'react';
import { SVGProps } from 'react';

const EnglishBanner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 344 100"
    {...props}
  >
    <path d="m103.66,14.12l6.92-22.13-49.24-15.4c-9.06-2.84-18.71,2.21-21.55,11.28s2.21,18.71,11.28,21.55c-9.06-2.84-18.71,2.21-21.55,11.28-2.84,9.06,2.21,18.71,11.28,21.55l49.24,15.4,6.92-22.13-6.49-2.03,6.69-21.39,6.49,2.03h0Z" />
    <path d="m266.87,15.36l23.06-25.01c-13.94-12.85-35.65-11.97-48.5,1.97h0c-2.86,3.1-5.04,6.59-6.54,10.28l-.05-.02c-2.78,6.83-3.18,14.04-1.62,20.71.03.14.07.28.1.43.07.3.15.6.24.9.09.32.18.65.28.97.04.12.07.23.11.35,1.74,5.52,4.89,10.68,9.46,14.89l.03-.03c2.93,2.69,6.39,4.92,10.29,6.51h0c5.45,2.21,11.13,2.92,16.59,2.33,1.24-.05,2.5-.24,3.75-.58l34.75-9.39-8.97-33.21-32.97,8.91h0s0,0,0,0Z" />
    <path d="m201.35,56.24h0c-8.92-3.26-18.8,1.33-22.06,10.25l-6.68,18.28-19.72-46.24-23.61,64.61,32.31,11.8,28.31,10.34,4,1.46,17.71-48.46c3.26-8.92-1.33-18.8-10.25-22.06Z" />
  </svg>
);

export default EnglishBanner;
